import styled from 'styled-components';

export const Subtitles = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export const Dates = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    flex: 1;
`;